import React, { useState, useEffect, useCallback, useRef } from 'react';

import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import CustomNavbar from '../components/Layout/CustomNavbar'; //header

import WordListBoard from '../components/WordList/WordListBoard';
import Soundboard from '../components/Soundboard/Soundboard';

import { useIdleTimer } from 'react-idle-timer';
import SessionTimeoutOverlay from './SessionTimeoutOverlay';

import { IconButton } from "@mui/material";
import { ChevronLeft as CollapseIcon, ChevronRight as ExpandIcon } from "@mui/icons-material";

import { useTranslation, Trans } from 'react-i18next';
import { useNotification } from '../contexts/NotificationContext'; 
//import { useData } from '../contexts/DataContext'; 
import { useAppData } from "../hooks/useAppData";
import { useUserData } from "../hooks/useUserData";
import { useUserStore } from "../hooks/useUserStore";

import { useAppStore } from "../hooks/useAppStore"; 

import '../styles/App.css';

function MainContent() {

  const { t } = useTranslation(); // Hook to access translation
  const { showNotification } = useNotification();

/*const { 
    stageWidth,
    setStageWidth,
    wordListWidth,
    setWordListWidth
  } = useData(); // Destructure wordListId from context*/

  const { 
      baseURL,
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      isWordListCollapsed, toggleWordList,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth,
      isPendingAssignWord, setIsPendingAssignWord,
      isPendingDeleteGroup, setIsPendingDeleteGroup
  } = useAppStore();

  /* Set loading cursor when wait for deleting word group, or assigning new word is too long */
  useEffect(() => {
    if (isPendingDeleteGroup  || isPendingAssignWord) {
      document.body.style.cursor = 'url("/cursors/loading-cursor.gif"), auto';
    } else {
      document.body.style.cursor = 'default';
    }    
    return () => {
      document.body.style.cursor = 'default'; // cleanup
    };
  }, [isPendingDeleteGroup, isPendingAssignWord]);

  const { 
      wordList, 
      isWordListPending,
      isWordListError, 
      wordListRefetch,
      updateWordList,
      updateWordListOnReorder,
      addGroup,
      deleteGroup,
      addWordItem,
      deleteWord,
      soundboard,
      shapes,
      isSoundboardPending,
      isSoundboardError, 
      soundboardRefetch,
      addShape,
      updateShape,
      updateButton,
      unassignButton,
      deleteShape,
      handleOptionChange,
      handleAssignedWordTooltipVisibility,
      assignedWordTooltipVisibility
    } = useAppData();

    const { 
      checkSession, 
      refreshToken, 
      validateToken 
    } = useUserData();

    const { 
      isSessionTimedOut,
      setIsSessionTimedOut
    } = useUserStore();


  const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));

  //const [isWordListCollapsed, setIsWordListCollapsed] = useState(false);
  const wordListRef = useRef(null);
  const toggleButtonRef = useRef(null);

  /*const axiosInstance = axios.create({
    baseURL,
    headers: {
      'Authorization': `Bearer ${userToken}`
    }
  });*/


  /*const refreshToken = useCallback(async () => {
    try {
      const response = await axiosInstance.post('/api/users/refreshToken');
      const newToken = response.data.accessToken;
      setUserToken(newToken);
      localStorage.setItem('userToken', newToken);
      axiosInstance.defaults.headers['Authorization'] = `Bearer ${newToken}`;
    } catch (error) {

      const extra = { 
        message: 'Failed to refresh token',
      };*/

      /**showNotification({
        notification: t('errors.snackbar.NotLoggedIn'),
        type: 'error',
        extra,
        error,
        isException: true,
        actions: [
          { label: 'Refresh', onClick: () => window.location.reload() },
        ],
      });**/

      /*setIsSessionTimedOut(true);
      localStorage.removeItem('userToken');
    }
  }, [axiosInstance]);*/

  const handleOnIdle = useCallback(() => {
    setIsSessionTimedOut(true);
    localStorage.removeItem('userToken');
  }, []);

  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * 30, // 1000 * 60 * 30 = 30 minutes
    onIdle: handleOnIdle,
    debounce: 500
  });

  /*const checkSession = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/api/users/checkSession');
      if (response.status === 200) {
        reset();
        ();
      }
    } catch (error) {

      const extra = { 
        message: 'Session check failed',
        responseData: error.response ? error.response.data : null,
        request: error.request ? error.request : null,
      };*/

      /**showNotification({
        notification: t('errors.snackbar.NotLoggedIn'),
        type: 'error',
        extra,
        error,
        isException: true,
        actions: [
          { label: 'Refresh', onClick: () => window.location.reload() },
        ],
      });**/

      /*if (error.response) {
        if (error.response.status === 401 || error.response.status === 404) {
          setIsSessionTimedOut(true);
          localStorage.removeItem('userToken');
        } else {
          
          const extra = { 
            responseData: error.response.data,
            message: 'Unexpected error during session check',
           };  

         /** showNotification({
            notification: t('errors.snackbar.NotLoggedIn'),
            type: 'error',
            extra,
            isException: false,
          });**/

       /* }
      } else if (error.request) {
        const extra = { 
          request: error.request,
          message: 'No response received during session check'
        };  */

        /**showNotification({
          notification: t('errors.snackbar.NotLoggedIn'),
          type: 'error',
          extra,
          isException: false,
        });**/

      /*} else {
        const extra = {           
          message: 'Error setting up request during session check'
        };  */

        /**showNotification({
          notification: t('errors.snackbar.NotLoggedIn'),
          type: 'error',
          extra,
          isException: false,
        });**/
     /* }
    }
  }, [axiosInstance, reset, refreshToken]);*/

  const isMobile = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  useEffect(() => {
      if (isMobile()) {
        showNotification({
            notification: t('errors.snackbar.MobileExperience'),
            type: 'info',
            isException: false,
          });
        }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('userToken')) {
      checkSession.mutate();
    }
  }, [userToken]);

  useEffect(() => {
    if (localStorage.getItem('userToken')) {
     validateToken.mutate();
    }
  }, []);

  useEffect(() => {
    reset();
  }, []);
    
  

  /*useEffect(() => {
    checkSession();
    const intervalId = setInterval(checkSession, 60000); // Check session every minute
    return () => clearInterval(intervalId);
  }, [checkSession]);

  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('userToken');

      if (!token) {
        setIsSessionTimedOut(true);
        return;
      }
  
      try {
        const response = await axiosInstance.post('/api/users/validateToken', { token });
        if (response.status !== 200) {
          setIsSessionTimedOut(true);
          localStorage.removeItem('userToken');
        }
      } catch (error) {
        setIsSessionTimedOut(true);
        localStorage.removeItem('userToken');
      }
    };
  
    validateToken();
  }, []);

  useEffect(() => {
    reset();
  }, []);*/

  // Update toggle button position dynamically
  useEffect(() => {
    const updateButtonPosition = () => {
      if (wordListRef.current && toggleButtonRef.current) {
        const newWidth = wordListRef.current.getBoundingClientRect().width;
        setWordListWidth(newWidth);

        // Dynamically update button position
        //toggleButtonRef.current.style.left = `${newWidth+10}px`;
      }
    };

    updateButtonPosition(); // Initial update
    //ec setTimeout(updateButtonPosition, 350); // Ensure update after CSS transition
    requestAnimationFrame(() => {
      updateButtonPosition(); // ✅ Runs after CSS transition
    });

    window.addEventListener("resize", updateButtonPosition);
    return () => window.removeEventListener("resize", updateButtonPosition);
  }, [isWordListCollapsed]);


  // Update sizes when wordlist collapses
  useEffect(() => {
    const updateSizes = () => {
      if (wordListRef.current) {
        setWordListWidth(wordListRef.current.offsetWidth);
      }
      setStageWidth(window.innerWidth - (isWordListCollapsed ? 10 : wordListWidth)); 
    };

    updateSizes();

    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, [isWordListCollapsed, wordListWidth]);
  

  if (isSessionTimedOut) {
    return <SessionTimeoutOverlay onClose={() => setIsSessionTimedOut(false)} />;
  }

  
  function updateGradientWidth() {
    const wordlistColumn = document.querySelector('.wordlist-column');
    const wordlistGradient = document.querySelector('.wordlist-gradient');
    if (wordlistColumn && wordlistGradient) {
      const wordlistColumnRect = wordlistColumn.getBoundingClientRect();
      wordlistGradient.style.width = `${wordlistColumnRect.width}px`;
      wordlistGradient.style.left = `${wordlistColumnRect.left}px`;
    }
  }

  window.addEventListener('resize', updateGradientWidth);
  window.addEventListener('scroll', updateGradientWidth);
  document.addEventListener('DOMContentLoaded', updateGradientWidth);

  
  return (
    <div className="app">
      <CustomNavbar />
      <div className="main-content">
        
      <div           
        ref={wordListRef}
        className={`wordlist-container ${isWordListCollapsed ? "collapsed" : "expanded"}`}
      >
          {/*<div className="wordlist-column">*/}
            <WordListBoard />
          {/*</div>*/}
          

        </div>

        {/* Toggle Button Positioned at the Border*/ }
        <div
          ref={toggleButtonRef} 
          className="wordlist-toggle-button"
        >
          <IconButton 
            onClick={toggleWordList} 
            size="small"
            sx={{ 
              fontSize: "10px", 
              background: "transparent", // No extra background
              borderRadius: "50%", // Ensure it stays circular
              padding: "0", // No extra padding
              "&:hover": { background: "none" }, // Remove MUI's default hover color
              "&:focus": { background: "none" }, // Remove focus background
              "&:active": { background: "none" } // Remove active background
             }}
            
            disableRipple
          >
            {isWordListCollapsed ? <ExpandIcon /> : <CollapseIcon />}
          </IconButton>
        </div>

        <div className="soundboard-container">
          <Soundboard />
        </div>
      </div>
    </div>
  );
}

export default MainContent;
